import React from 'react';

import * as S from './styles';

function Spades() {
  return <S.Gispades />;
}

export default Spades;